"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AST = require("./grammar");
exports.AST = AST;
var parser_1 = require("./parser");
exports.parse = parser_1.default;
